"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pagination_1 = require("shared/pagination");
const useIntersectionElement_1 = __importDefault(require("./useIntersectionElement"));
const DEFAULT_TOTAL_PAGES = 0;
const useInfinityScrollPagination = ({ totalPages = DEFAULT_TOTAL_PAGES } = {}) => {
    const { elementToObserverRef, intersectionCount, reset } = (0, useIntersectionElement_1.default)();
    const hasNextPage = intersectionCount === pagination_1.DEFAULT_FIRST_PAGE ||
        (intersectionCount > pagination_1.DEFAULT_FIRST_PAGE && intersectionCount < totalPages);
    return {
        elementToObserverRef,
        pageNumber: intersectionCount,
        hasNextPage,
        reset
    };
};
exports.default = useInfinityScrollPagination;
